import Formation, { TypeFormation } from "../../models/Formation";

import FormationsManager from "../formations-manager.webp";
import FormationsManagerHand from "../formations-manager-hand.webp";
import FormationsManagerTeam from "../formations-manager-team.webp";
import FormationsManagerWork from "../formations-manager-work.webp";
import FormationsManagerWorkTwo from "../formations-manager-work-two.webp";
import FormationsManagerLeadership from "../formations-manager-leadership.webp";
import FormationsManagerPerso from "../formations-manager-perso.webp";
import FormationsParcoursFemmes from "../formations-parcours-femmes.webp";
import FormationsCentreMedical from "../formations-centre-medical.webp";
import FormationsCohesionEquipe from "../formations-cohesion-equipe.webp";
import FormationsManagerTech from "../formations-manager-tech.webp";

import formationReveler from "./formations/formation-reveler";
import formationFondamentauxManager from "./formations/formation-fondamentaux-manager";
import formationManagerCreativite from "./formations/formation-manager-creativite";
import formationManagerEquipe from "./formations/formation-manager-equipe";
import formationManagerLeadership from "./formations/formation-manager-leadership";
import formationManagerPersonnalites from "./formations/formation-manager-personnalites";
import formationsSpecifiques from "./formations/formation-specifiques";
import formationParcoursDeFemmes from "./formations/formation-parcours-de-femmes";
import formationCentreMedical from "./formations/formation-centre-medical";
import formationCohesionEquipe from "./formations/formation-cohesion-equipe";
import formationManagerPetiteStructureTech from "./formations/formation-manager-petite-structure-tech";

const formationsData: Formation[] = [
  {
    image: FormationsManagerWorkTwo,
    title: "Formation : Les fondamentaux du manager",
    description:
      "Cette formation vous offre une immersion totale dans les principes fondamentaux du management, vous équipant des compétences indispensables pour diriger avec succès et efficacité.",
    id: "formation-fondamentaux-manager",
    content: formationFondamentauxManager,
    type: TypeFormation.FormationCatalogue
  },
  {
    image: FormationsManagerWork,
    title:
      "Formation : Révéler les competences & les talents de vos collaborateurs",
    description:
      "Cette formation vous fournit, vous managers, les compétences essentielles pour accompagner efficacement vos collaborateurs. Vous apprendrez à définir un plan d'action précis pour développer les compétences de votre équipe.",
    id: "formation-reveler",
    content: formationReveler,
    type: TypeFormation.FormationCatalogue
  },
  {
    image: FormationsManagerHand,
    title:
      "Formation : Manager son équipe dans une situation d’incertitude ou de crise",
    description:
      "Cette formation vise à vous doter des compétences et des stratégies nécessaires pour naviguer avec efficacité et sensibilité à travers toutes les étapes des situations de crise et d'incertitude. ",
    id: "formation-manager-equipe",
    content: formationManagerEquipe,
    type: TypeFormation.FormationCatalogue
  },
  {
    image: FormationsManagerLeadership,
    title:
      "Formation : Leadership de proximité, Manager avec impact au quotidien",
    description:
      "Cette formation vous fournira toutes les clés pour définir et affirmer votre posture de manager. Elle permet de valoriser l’autonomie des collaborateurs, de susciter l’engagement de l’équipe et de gérer efficacement les conflits.",
    id: "formation-manager-leadership",
    content: formationManagerLeadership,
    type: TypeFormation.FormationCatalogue
  },
  {
    image: FormationsManagerPerso,
    title: "Formation : Gérer les personnalités difficiles dans son équipe",
    description:
      "Les personnalités difficiles dans une équipe sont un frein au travail collectif. Le manager doit apprendre à les canaliser. Ce stage vous permettra de perfectionner votre communication et de choisir la meilleure posture relationnelle afin de rétablir le dialogue pour une collaboration efficace.",
    id: "formation-manager-personalites",
    content: formationManagerPersonnalites,
    type: TypeFormation.FormationCatalogue
  },
  {
    image: FormationsManagerTeam,
    title: "Formation : Manager, booster la creativite de son équipe",
    description:
      "Cette formation vise à vous doter des compétences et des stratégies nécessaires pour naviguer avec efficacité et sensibilité à travers toutes les étapes des situations de crise et d'incertitude. ",
    id: "formation-manager-creativite",
    content: formationManagerCreativite,
    type: TypeFormation.FormationCatalogue
  },
  {
    image: FormationsManager,
    title: "Formations spécifiques sur mesure",
    description:
      "Chez Natelco, nous croyons que chaque organisation est unique. C’est pourquoi nous proposons des formations spécifiquement conçues selon vos besoins.",
    id: "formations-specifiques",
    content: formationsSpecifiques,
    type: TypeFormation.FormationSpecifique
  },
  {
    image: FormationsParcoursFemmes,
    title: "Parcours de femmes",
    description:
      "Le Parcours de Femmes est un dispositif unique qui s’adresse aux femmes entrepreneures, collaboratrices, salariées ou indépendantes souhaitant développer leur potentiel personnel et professionnel, anticiper les transitions et relever les défis avec confiance.",
    id: "formation-parcours-femmes",
    content: formationParcoursDeFemmes,
    type: TypeFormation.FormationTendance
  },
  {
    image: FormationsCentreMedical,
    title: "Formations des centres Médicaux",
    description:
      "Les Formations des Centres Médicaux sont conçues pour les professionnel·les de santé et les équipes médicales souhaitant renforcer leurs compétences, améliorer leur coordination et s’adapter aux évolutions du secteur. Ces formations allient expertise métier, cas pratiques et outils opérationnels pour répondre aux enjeux spécifiques du milieu médical.",
    id: "formation-centre-medical",
    content: formationCentreMedical,
    type: TypeFormation.FormationTendance
  },
  {
    image: FormationsCohesionEquipe,
    title: "Formation : Renforcer la cohésion d’équipe",
    description:
      "Cette formation permet d’identifier les leviers qui renforcent le collectif et d’acquérir des pratiques concrètes pour mieux mobiliser son équipe, faciliter les échanges et installer une dynamique de coopération durable.",
    id: "formation-cohesion-equipe",
    content: formationCohesionEquipe,
    type: TypeFormation.FormationCatalogue
  },
  {
    image: FormationsManagerTech,
    title: "Formation : Manager une petite structure Tech",
    description:
      "Une formation sur mesure pour structurer l’organisation, renforcer le management de proximité, piloter la relation client et coordonner efficacement les prestataires.",
    id: "formation-manager-petite-structure-tech",
    content: formationManagerPetiteStructureTech,
    type: TypeFormation.FormationSpecifique
  }
];

export default formationsData;
